export interface PopupCard {
  id: string;
  title: string;
  price: string;
  bullets: string[];
  image: string;
}

/** Parses the popup.cards override. Returns [] when unset or invalid. */
export function parsePopupCards(raw: string): PopupCard[] {
  if (!raw || !raw.trim()) return [];
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return [];
  }
  if (!Array.isArray(parsed)) return [];
  const cards: PopupCard[] = [];
  parsed.forEach((entry, i) => {
    if (!entry || typeof entry !== "object" || Array.isArray(entry)) return;
    const e = entry as Record<string, unknown>;
    const title = typeof e.title === "string" ? e.title : "";
    const bullets = Array.isArray(e.bullets)
      ? e.bullets.filter((b): b is string => typeof b === "string" && b.trim().length > 0)
      : [];
    if (!title && !bullets.length) return;
    const image = typeof e.image === "string" && /^https:\/\//i.test(e.image.trim())
      ? e.image.trim()
      : "";
    cards.push({
      id: typeof e.id === "string" && e.id ? e.id : `card-${i}`,
      title,
      price: typeof e.price === "string" ? e.price : "",
      bullets,
      image,
    });
  });
  return cards;
}
